import schugdaddy from './logo512.png';
import './App.css';
import { useState, useEffect } from 'react';

function App() {
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const calculateTimeLeft = () => {
      const targetDate = new Date('2026-12-25T00:00:00').getTime();
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          years: Math.floor(difference / (1000 * 60 * 60 * 24 * 365)),
          months: Math.floor((difference % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24 * 30)),
          days: Math.floor((difference % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  return (
    <div className="App">
      <header className="App-header">
        <div className="text-container">
          <p className="fade-text fade-text-1">
            "What we have once enjoyed we can never lose. All that we love deeply becomes a part of us."
          </p>
          <p className="fade-text fade-text-2">
            "Things we lose have a way of coming back to us in the end."
          </p>
          <p className="fade-text fade-text-3">
            He loves you
          </p>
          <img src={schugdaddy} alt="SchugDaddy Logo" className="fade-in-image" />
          <div className="countdown-timer">
            <div className="timer-unit">
              <div className="timer-value">{String(timeLeft.years || 0).padStart(2, '0')}</div>
              <div className="timer-label">years</div>
            </div>
            <div className="timer-unit">
              <div className="timer-value">{String(timeLeft.months || 0).padStart(2, '0')}</div>
              <div className="timer-label">months</div>
            </div>
            <div className="timer-unit">
              <div className="timer-value">{String(timeLeft.days || 0).padStart(2, '0')}</div>
              <div className="timer-label">days</div>
            </div>
            <div className="timer-unit">
              <div className="timer-value">{String(timeLeft.hours || 0).padStart(2, '0')}</div>
              <div className="timer-label">hours</div>
            </div>
            <div className="timer-unit">
              <div className="timer-value">{String(timeLeft.minutes || 0).padStart(2, '0')}</div>
              <div className="timer-label">minutes</div>
            </div>
            <div className="timer-unit">
              <div className="timer-value">{String(timeLeft.seconds || 0).padStart(2, '0')}</div>
              <div className="timer-label">seconds</div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
